import { Button, Menu, MenuItem } from "@mui/material";
import { useEffect, useState } from "react";

const SortArray = [
  { label: "Featured", value: "desc", key: 'featured' },
  { label: "High to Low", value: "asc", key: 'interest' },
  { label: "Low to High", value: "desc", key: 'interest' },
  { label: "A to Z", value: "asc", key: 'name' },
  { label: "Z to A", value: "desc", key: 'name' },
];

const getSortLabel = (value) => {
  const temp = SortArray?.filter((it) => it?.value === value.sortOrder && it?.key === value.sortKey);
  return temp[0]?.label;
};

const SortBy = (props) => {
  const [sortByVal, setSortByVal] = useState(
    props?.value !== null && props?.value !== undefined
      ? getSortLabel(props.value)
      : "Featured"
  );

  useEffect(() => {
    if (props?.value) {
      setSortByVal(getSortLabel(props.value));
    }
  }, [props?.value]);

  const [sortByEl, setsortByEl] = useState(null);
  const dropdownopen = Boolean(sortByEl);
  const handleDropdownClick = (event) => {
    setsortByEl(event.currentTarget);
  };
  const handleDropdownChange = (ans) => {
    props.handleSortBy(ans);
    setSortByVal(ans);
    setsortByEl(null);
  };
  return (
    <div
      className={`select_opt relative bottom-[2px] pl-[20px] right-[20px] cursor-pointer shrink-0`}
    >
      <img
        src="/images/select_icon2.svg"
        alt="arrow"
        className="absolute top-[11px] left-[22px]"
      />
      <img
        src="/images/select_icon1.svg"
        alt="arrow"
        className="absolute top-[15px] right-[2px]"
      />
      <Button
        id="sortby-button"
        aria-controls={dropdownopen ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={dropdownopen ? "true" : undefined}
        onClick={handleDropdownClick}
      >
        {sortByVal}
      </Button>
      <Menu
        id="sortby-menu"
        anchorEl={sortByEl}
        open={dropdownopen}
        onClose={() => setsortByEl(null)}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        defaultValue={"Featured"}
      >
        {SortArray.map((item, idx) => {
          return (
            <MenuItem
              // key={item?.value}         
              key={`${item.value}-${idx}`}
              onClick={() => handleDropdownChange(item?.label)}
            >
              {item?.label}
            </MenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default SortBy;
